import React from "react";
import { Link } from "react-router-dom";
import { Gift, ArrowUpRight } from "lucide-react";
import { GIFT } from "../../mock/mock";

const OwnersGift = () => {
  return (
    <>
      {/* Lime-yellow scrolling banner sitting right above the section */}
      <div className="bg-[#D8D355] py-2.5 overflow-hidden">
        <div className="overflow-hidden whitespace-nowrap">
          <div className="inline-flex om-marquee-track-reverse">
            {Array.from({ length: 18 }).map((_, i) => (
              <span
                key={i}
                className="px-6 text-[#41232E] font-medium tracking-[0.2em] uppercase text-xs"
              >
                Clarity, choice, freedom
                <span className="opacity-40 pl-6">/</span>
              </span>
            ))}
          </div>
        </div>
      </div>

      <section id="gift" className="grid md:grid-cols-2 min-h-[560px] md:min-h-[640px] bg-[#FFFDF6]">
      {/* Left — light cream side with copy + CTA */}
      <div className="flex items-center px-6 md:px-16 lg:px-24 py-20 md:py-24">
        <div className="max-w-lg om-fade-up">
          <div className="inline-flex items-center gap-2 bg-[#41232E]/5 border border-[#41232E]/12 rounded-full px-3 py-1.5 text-[0.7rem] tracking-[0.24em] uppercase text-[#41232E]/75 mb-8">
            <Gift size={12} /> {GIFT.cadence}
          </div>

          <h2 className="font-serif-display text-[#41232E] text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-[-0.02em]">
            {GIFT.headline}
          </h2>

          <p className="mt-6 text-[#41232E]/80 text-base md:text-lg leading-relaxed">
            {GIFT.sub} It&rsquo;s not a giveaway or a popularity contest &mdash; just a small
            celebration of people who are actually doing the work of building something they care
            about.
          </p>

          <Link
            to="/owners-gift"
            className="mt-8 inline-flex items-center gap-2 rounded-full px-6 py-3 bg-[#41232E] text-[#FFFDF6] hover:bg-[#2c161e] transition-colors"
          >
            Learn more <ArrowUpRight size={16} />
          </Link>
        </div>
      </div>

      {/* Right — living room photo bg with floating amount card */}
      <div className="relative flex items-center justify-center px-6 md:px-12 py-16 md:py-24 overflow-hidden">
        <img
          src="https://customer-assets-wrfwihn1.emergentagent.net/job_mindful-owner/artifacts/wvlynsvj_2fab0a2c17811d64c19ced10e52e562e.jpg"
          alt="A warm, considered living room"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#41232E]/15" />

        <div className="relative om-fade-up">
          <div className="bg-[#FFFDF6] rounded-[1.75rem] shadow-[0_20px_60px_rgba(65,35,46,0.28)] p-10 md:p-14 lg:p-16 max-w-md text-center">
            <div className="uppercase tracking-[0.28em] text-[0.7rem] text-[#605F26] mb-6">
              Every quarter
            </div>
            <div className="font-serif-display text-[#41232E] text-[5.5rem] md:text-[7rem] leading-none">
              {GIFT.amount}
            </div>
            <div className="mt-6 font-serif-display italic text-[#605F26] text-2xl md:text-3xl">
              for someone doing the work.
            </div>

            <div className="mt-10 flex items-center justify-center gap-4 text-xs tracking-[0.22em] uppercase text-[#41232E]/60">
              <span>Apply</span>
              <span className="w-8 h-px bg-[#41232E]/25" />
              <span>Share</span>
              <span className="w-8 h-px bg-[#41232E]/25" />
              <span>Celebrate</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default OwnersGift;
